// extracted by mini-css-extract-plugin
module.exports = {"ancillaries":"AncillariesBanner_ancillaries__mErr_","ancillariesContent":"AncillariesBanner_ancillariesContent__jQnvV"};